import { render } from "./mainView.vue?vue&type=template&id=3c9433de&scoped=true"
import script from "./mainView.vue?vue&type=script&lang=js"
export * from "./mainView.vue?vue&type=script&lang=js"

import "./mainView.vue?vue&type=style&index=0&id=3c9433de&scoped=true&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c9433de"]])

export default __exports__